import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiPhone, FiMapPin, FiShield } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" itemScope itemType="https://schema.org/WPFooter">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <SafeIcon icon={FiShield} className="text-teal-400 text-2xl mr-2" />
              <span className="text-xl font-bold tracking-wider">ZARDOZ.ai</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Zero-Audit Resilient Defense Over Zero-Knowledge.
              <br/>
              The god of unseen defenses for enterprise AI security.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-start"><SafeIcon icon={FiPhone} className="text-teal-400 mr-3 mt-1" /><div><div className="font-medium">Secure Line</div><a href="tel:+1888ZARDOZ" className="text-teal-400 hover:text-teal-300">+1-888-ZARDOZ-AI</a></div></div>
              <div className="flex items-start"><SafeIcon icon={FiMail} className="text-teal-400 mr-3 mt-1" /><div><div className="font-medium">Encrypted Email</div><a href="mailto:contact@zardoz.ai" className="text-teal-400 hover:text-teal-300">contact@zardoz.ai</a></div></div>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><a href="#privacy" className="text-gray-400 hover:text-teal-400 text-sm">Privacy Protocol</a></li>
              <li><a href="#terms" className="text-gray-400 hover:text-teal-400 text-sm">Service Agreement</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.6 }} viewport={{ once: true }} className="text-center text-gray-400 text-sm">
            © {currentYear} Zardoz.ai. All rights reserved. Zero-Audit Architecture.
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;